import supabase from "../supabaseClient/supabaseClient";

export async function saveWorksheet({
  id,
  userId,
  templateId,
  title,
  content,
  sourcePrompt,
}) {
  const payload = {
    user_id: userId,
    template_id: templateId,
    title: title || "Untitled worksheet",
    content,
    source_prompt: sourcePrompt ?? null,
    updated_at: new Date().toISOString(),
  };

  const { data, error } = id
    ? await supabase.from("worksheets").update(payload).eq("id", id).select().single()
    : await supabase.from("worksheets").insert(payload).select().single();

  if (error) console.error("Failed to save worksheet:", error);
  return { data, error };
}

export async function listWorksheets(userId) {
  const { data, error } = await supabase
    .from("worksheets")
    .select("id, title, template_id, created_at, updated_at")
    .eq("user_id", userId)
    .order("updated_at", { ascending: false });

  if (error) console.error("Failed to list worksheets:", error);
  return { data: data || [], error };
}

export async function renameWorksheet(id, title) {
  const { error } = await supabase
    .from("worksheets")
    .update({ title, updated_at: new Date().toISOString() })
    .eq("id", id);

  if (error) console.error("Failed to rename worksheet:", error);
  return { error };
}

export async function countWorksheets(userId) {
  const { count, error } = await supabase
    .from("worksheets")
    .select("id", { count: "exact", head: true })
    .eq("user_id", userId);

  if (error) console.error("Failed to count worksheets:", error);
  return { count: count || 0, error };
}

export async function getWorksheet(id) {
  const { data, error } = await supabase
    .from("worksheets")
    .select("*")
    .eq("id", id)
    .single();

  if (error) console.error("Failed to load worksheet:", error);
  return { data, error };
}

export async function deleteWorksheet(id) {
  // Postgres RLS silently no-ops a delete that matches no policy — it
  // returns success with zero rows affected, not an error — so request the
  // deleted row back and treat an empty result as a failure too, otherwise
  // callers would optimistically remove it from the UI while it's still in
  // the database (e.g. before the delete RLS policy has been added).
  const { data, error } = await supabase.from("worksheets").delete().eq("id", id).select();

  if (error) {
    console.error("Failed to delete worksheet:", error);
    return { error };
  }

  if (!data || data.length === 0) {
    const notDeletedError = new Error(
      "Delete affected no rows — check the worksheets DELETE policy in Supabase."
    );
    console.error(notDeletedError.message);
    return { error: notDeletedError };
  }

  return { error: null };
}
